import * as ResultsCustomOutputBasic from './resultsCustomOutputBasic.js';
export default ResultsCustomOutputBasic;
